import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';

import apiAbout from '../../api/About';
import { spanish } from '../../config/config';

import Content from '../../components/About';

const About = () => {
  const [content, setContent] = useState(null);
  useEffect(async () => {
    setContent(await apiAbout.getContent());
  }, []);
  return (
    <div>
      <Helmet title={spanish ? 'Acerca de nosotros' : 'About us'} />
      <Content content={content} />
    </div>
  );
};

export default About;
